module.exports = __webpack_public_path__ + "static/media/search.393df67b.svg";